import React from "react";
import styles from "./styles.module.scss";
import { ArrowRightIcon } from "../../../../../../../../../../assets/Icons/ArrowRightIcon";

export const Heading = ({ title, index, description }) => (
  <div className={styles.root}>
    <div className={styles.top}>
      <div className={styles.left}>
        <span>{index}</span>
        <ArrowRightIcon width="16px" />
      </div>
      {title}
    </div>
    {description && <div className={styles.description}>{description}</div>}
  </div>
);
